var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({style:({ width: '100%', height: '100%' })},_vm.$listeners),[(_vm.isError !== true)?_c('div',{staticClass:"echart",style:({
      float: 'left',
      width: '100%',
      height: '100%',
    }),attrs:{"id":_vm.controlid}}):_c('div',{staticClass:"logmsg"},[_vm._v(_vm._s(_vm.logmsg))])])
}
var staticRenderFns = []

export { render, staticRenderFns }